import { render, staticRenderFns } from "./addMonitorTask.vue?vue&type=template&id=f1769e0a&"
import script from "./addMonitorTask.vue?vue&type=script&lang=js&"
export * from "./addMonitorTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports